import axios from 'axios'

export const getJobAdvertisements = async (
    backendUrl: string,
    myDealerCode?: string
) => {
    try {
        const response = await axios.get(
            `${backendUrl}/api/v1/job-advertisements${
                myDealerCode ? `/${myDealerCode}` : ``
            }`
        )

        return response.data
    } catch (e) {
        console.log('error', e)
        throw e
    }
}
